module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web29.65cc1459.jpg";